export default {
  message: {
    Tour: {
      continue: "Продовжити",
      back: "Назад",
      finish: "Готово"
    },
    Login: {
      title: "Вхід для батьків",
      sign_in: "Увійти",
      login_fail:
        "Помилка автентифікації. Спробуйте ще раз або зверніться до школи за допомогою.",
      forgot_password: "Забули пароль",
      create_account: "Створити обліковий запис",
      password: "Пароль",
      confirm_password: "Підтвердіть пароль",
      password_reminder: "Нагадування пароля",
      enter_email: "Введіть вашу електронну адресу",
      validation_error: "Повідомлення про помилку валідації",
      password_reminder_error_no_user_register:
        "Користувача не знайдено. Спробуйте ще раз або створіть новий обліковий запис.",
      password_reminder_error_no_user: "Користувача не знайдено.",
      password_reminder_sent: "Лист з інструкціями надіслано на {email}.",
      password_reminder_sent_message:
        "Лист може надійти протягом кількох хвилин. Перевірте папку «Спам».",
      password_trouble_email: "Якщо проблема зберігається, зв'яжіться з {email}.",
      password_trouble_school:
        "Якщо проблема зберігається, зверніться до школи за допомогою.",
      return_to_sign_in: "Повернутися до входу",
      create_my_account: "Створити обліковий запис",
      or_sign_in_with: "АБО УВІЙТИ ЗА ДОПОМОГОЮ",
      password_reset: "Оберіть новий пароль для вашого облікового запису.",
      password_reset_warning:
        "Якщо ви не запитували зміну пароля, негайно зв'яжіться з адміністратором школи.",
      password_update: "Оберіть новий пароль",
      password_update_confirm: "Підтвердіть новий пароль",
      password_update_success: "Ваш новий пароль збережено."
    },
    AccountSettings: {
      title: "Налаштування облікового запису",
      first_name: "Ім'я",
      last_name: "Прізвище",
      email: "Email",
      username: "Ім'я користувача",
      password: "Пароль",
      students: "Учні",
      teachers: "Вчителі",
      external_id: "Зовнішній ID",
      phone: "Номер телефону",
      phone_required: "Номер телефону обов'язковий",
      edit: "Редагувати",
      remove: "Видалити",
      add: "Додати",
      remove_message: "Видалити цього учня?",
      yes: "Так",
      no: "Ні",
      add_student: "Додати учня",
      close: "Закрити",
      save: "Зберегти",
      cancel: "Скасувати",
      student_alert_message: "Необхідно вказати хоча б одного учня.",
      logout: "Вийти"
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "Мої зустрічі",
      language: "Українська",
      help: "Допомога",
      account_settings: "Налаштування облікового запису",
      user_management: "User Management",
      logout: "Вийти"
    },
    SubNavbar: {
      meeting: "Зустріч",
      event: "Подія",
      print: "Друк",
      email: "Email",
      export: "Експорт"
    },
    ConferenceCard: {
      add_edit_meetings: "Додати/змінити зустрічі",
      opening: "Відкрито",
      closed: "Закрито"
    },
    Agenda: {
      full_agenda: "Повний порядок денний",
      empty_state_title: "Для вас немає запланованих конференцій.",
      empty_state_message: "За питаннями звертайтесь до школи.",
      confirmation_modal_title: "Порядок денний підтверджено",
      confirmation_modal_message:
        "Порядок денний підтверджено. Вам надіслано листа на email.",
      complete_button: "Готово!"
    },
    AgendaCard: {
      room: "Кімната недоступна",
      room_with_value: "Кімната: {room}",
      virtual_meeting: "Онлайн-зустріч",
      all_conferences: "Всі конференції",
      conference: "Конференція",
      student: "Учень",
      meeting_with: "Зустріч з",
      date_time: "Дата/час",
      meeting_type: "Тип зустрічі",
      location: "Місце",
      comment: "Коментар",
      action: "Дія",
      delete: "Видалити",
      add_comment: "Додати коментар",
      join: "Приєднатися",
      choose_meeting_type: "Оберіть тип зустрічі",
      in_person: "Особисто",
      phone: "Телефон",
      callback: "Передзвон",
      virtual: "Онлайн",
      hybrid: "Гібрид",
      unavailable: "Недоступно",
      tooltip_translator:
        "Послуги перекладача не гарантовані, але школа докладе всіх зусиль для їх надання.",
      translator_requested: "Запрошено перекладача",
      clear_translator: "Скасувати запит перекладача",
      need_translator: "Потрібен перекладач?",
      choose_language: "Оберіть мову"
    },
    ScheduleMatrix: {
      no_teachers_title: "Вчителі або команди не обрані.",
      no_teachers_message: "Оберіть вчителя для перегляду часу зустрічей.",
      choose_teachers_button: "Переглянути доступних вчителів",
      choose_student: "Для якого учня?",
      cancel: "Скасувати"
    },
    Matrix: {
      teachers: "Вчителі",
      agenda: "Перевірити та продовжити"
    },
    DrawerTeachers: {
      teachers: "Вчителі",
      name: "Ім'я",
      description: "Опис",
      student: "Учень",
      teacher_team: "Вчитель/команда",
      show_more: "Показати ще",
      show_all: "Показати всіх вчителів школи",
      selected: "({count}) обрано",
      closeDrawer: "Продовжити планування",
      search: "Пошук вчителя або команди",
      not_available: "У цього вчителя немає доступного часу на {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "У вас немає запланованих зустрічей.",
      no_meetings_message: "Після вибору вчителя та часу зустріч з'явиться тут.",
      new_meeting_label: "Нова",
      cancel_button: "Скасувати",
      student_label: "Учень",
      meeting_type_location: "Тип зустрічі/місце",
      comment_label: "Коментар",
      save_comment_button: "Зберегти",
      confirm_label: "Підтвердіть:",
      confirm_cancel_button: "Так, скасувати зустріч з ",
      do_not_cancel_button: "Не скасовувати",
      confirm_agenda_button: "Підтвердити порядок денний",
      confirm_agenda_message_line1: "Ви завжди можете повернутися та змінити.",
      confirm_agenda_message_line2: "Порядок денний буде надіслано вам на email."
    },
    EmailConsent: {
      message:
        "Для захисту вашої конфіденційності необхідно підтвердити отримання повідомлень на вашу електронну адресу.",
      consent: "Згоден"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    },
    Events: {
      loadError: "Не вдалося завантажити події.",
      retry: "Повторити"
    }
  }
};
